// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-type-page {
  background: var(--order-type-bg);
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.order-type-page .order-type-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.order-type-page .order-type-header ion-toolbar {
  --background: transparent;
  --color: var(--text-primary-dark);
}
.order-type-page .order-type-header ion-toolbar .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md) var(--page-padding);
  height: var(--header-height);
  padding: 0;
}
.order-type-page .order-type-header ion-toolbar .header-content .logo {
  font-size: var(--logo-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--logo-color);
  font-family: var(--font-family-primary);
}
.order-type-page .order-type-header ion-toolbar .header-content .back-button,
.order-type-page .order-type-header ion-toolbar .header-content .menu-button {
  background: transparent;
  border: none;
  color: var(--menu-button-color);
  cursor: pointer;
  padding: var(--spacing-sm);
  border-radius: var(--border-radius-sm);
  transition: background-color 0.2s ease;
}
.order-type-page .order-type-header ion-toolbar .header-content .back-button:hover,
.order-type-page .order-type-header ion-toolbar .header-content .menu-button:hover {
  background: rgba(255, 255, 255, 0.1);
}
.order-type-page .order-type-header ion-toolbar .header-content .back-button ion-icon,
.order-type-page .order-type-header ion-toolbar .header-content .menu-button ion-icon {
  font-size: 24px;
}
.order-type-page .order-type-header ion-toolbar .header-content .back-button {
  margin-right: auto;
}
.order-type-page .order-type-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl) var(--page-padding);
  position: relative;
}
.order-type-page .question-section {
  margin-bottom: var(--spacing-3xl);
  text-align: center;
}
.order-type-page .question-section .question-text {
  color: var(--order-type-color);
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-tight);
  margin: 0;
  max-width: 500px;
  letter-spacing: -0.01em;
}
@media (max-width: 768px) {
  .order-type-page .question-section .question-text {
    font-size: 28px;
  }
}
@media (max-width: 480px) {
  .order-type-page .question-section .question-text {
    font-size: 24px;
  }
}
.order-type-page .options-section {
  margin-bottom: var(--spacing-3xl);
}
.order-type-page .options-section .option-buttons {
  display: flex;
  gap: var(--spacing-3xl);
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .order-type-page .options-section .option-buttons {
    gap: var(--spacing-xl);
  }
}
@media (max-width: 480px) {
  .order-type-page .options-section .option-buttons {
    flex-direction: column;
    gap: var(--spacing-lg);
  }
}
.order-type-page .options-section .option-buttons .option-btn {
  width: var(--option-btn-size);
  height: var(--option-btn-size);
  background: var(--option-btn-bg);
  color: var(--option-btn-color);
  border: none;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  transition: all 0.3s ease;
  box-shadow: var(--option-btn-shadow);
  position: relative;
}
.order-type-page .options-section .option-buttons .option-btn:hover {
  transform: scale(1.05);
  box-shadow: var(--option-btn-shadow-hover);
}
.order-type-page .options-section .option-buttons .option-btn:active {
  transform: scale(0.98);
}
.order-type-page .options-section .option-buttons .option-btn.selected {
  transform: scale(1.05);
  box-shadow: var(--option-btn-shadow-hover);
}
.order-type-page .options-section .option-buttons .option-btn.selected::after {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 3px solid var(--button-primary);
  border-radius: var(--border-radius-full);
  animation: selectedPulse 2s ease-in-out infinite;
}
.order-type-page .options-section .option-buttons .option-btn .option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-type-page .options-section .option-buttons .option-btn .option-icon ion-icon {
  font-size: 48px;
  color: var(--option-btn-color);
}
.order-type-page .options-section .option-buttons .option-btn .option-label {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--option-btn-color);
  text-align: center;
  line-height: var(--line-height-tight);
}
@media (max-width: 768px) {
  .order-type-page .options-section .option-buttons .option-btn {
    width: 160px;
    height: 160px;
  }
  .order-type-page .options-section .option-buttons .option-btn .option-icon ion-icon {
    font-size: 40px;
  }
  .order-type-page .options-section .option-buttons .option-btn .option-label {
    font-size: var(--font-size-caption);
  }
}
@media (max-width: 480px) {
  .order-type-page .options-section .option-buttons .option-btn {
    width: 140px;
    height: 140px;
  }
  .order-type-page .options-section .option-buttons .option-btn .option-icon ion-icon {
    font-size: 36px;
  }
}
.order-type-page .payment-methods {
  position: absolute;
  bottom: var(--spacing-xl);
  transform: translateX(-50%);
}
.order-type-page .payment-methods .payment-icons {
  display: flex;
  gap: var(--spacing-md);
  align-items: center;
  justify-content: center;
}
.order-type-page .payment-methods .payment-icons .payment-icon {
  height: 32px;
  width: 32px;
  object-fit: contain;
}
.order-type-page .payment-methods .payment-icons .payment-icon.twint {
  width: 65px;
}

@keyframes selectedPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.02);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.order-type-page {
  animation: fadeInUp 0.6s ease-out;
}

.question-section {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.options-section {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}
.options-section .option-btn:nth-child(1) {
  animation: scaleIn 0.5s ease-out 0.6s both;
}
.options-section .option-btn:nth-child(2) {
  animation: scaleIn 0.5s ease-out 0.7s both;
}

.payment-methods {
  animation: fadeInUp 0.6s ease-out 0.8s both;
}

@media (prefers-color-scheme: dark) {
  .order-type-page .option-btn {
    box-shadow: var(--shadow-dark-lg);
  }
  .order-type-page .option-btn:hover, .order-type-page .option-btn.selected {
    box-shadow: var(--shadow-dark-xl);
  }
}
.option-btn:focus {
  outline: 3px solid var(--vendomat-blue-light);
  outline-offset: 4px;
}

@media (prefers-contrast: high) {
  .option-btn {
    border: 2px solid var(--text-primary-light);
  }
  .option-btn.selected {
    border-color: var(--button-primary);
    border-width: 4px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .option-btn {
    transition: none;
  }
  .option-btn:hover {
    transform: none;
  }
  .option-btn.selected::after {
    animation: none;
  }
  .order-type-page,
  .question-section,
  .options-section,
  .payment-methods,
  .option-btn {
    animation: none;
  }
}
.external-link-section {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  margin: 5px;
}
.external-link-section button {
  display: flex;
  background: transparent;
  padding: 8px 12px;
  gap: 5px;
  margin: 5px;
  border-radius: 6px;
  border: 1px solid #2D69AA;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-type-selection/order-type-selection.component.scss"],"names":[],"mappings":"AAGA;EACE,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAHJ;AAKI;EACE,yBAAA;EACA,iCAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,4BAAA;EACA,UAAA;AAHR;AAKQ;EACE,gCAAA;EACA,uCAAA;EACA,wBAAA;EACA,uCAAA;AAHV;AAMQ;;EAEE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,0BAAA;EACA,sCAAA;EACA,sCAAA;AAJV;AAMU;;EACE,oCAAA;AAHZ;AAMU;;EACE,eAAA;AAHZ;AAOQ;EACE,kBAAA;AALV;AAYE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,kBAAA;AAVJ;AAcE;EACE,iCAAA;EACA,kBAAA;AAZJ;AAcI;EACE,8BAAA;EACA,8BAAA;EACA,uCAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAZN;AAeM;EAVF;IAWI,eAAA;EAZN;AACF;AAcM;EAdF;IAeI,eAAA;EAXN;AACF;AAgBE;EACE,iCAAA;AAdJ;AAgBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAdN;AAiBM;EAPF;IAQI,sBAAA;EAdN;AACF;AAgBM;EAXF;IAYI,sBAAA;IACA,sBAAA;EAbN;AACF;AAeM;EACE,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;EACA,wCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;AAbR;AAgBQ;EACE,sBAAA;EACA,0CAAA;AAdV;AAkBQ;EACE,sBAAA;AAhBV;AAoBQ;EACE,sBAAA;EACA,0CAAA;AAlBV;AAoBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,wCAAA;EACA,gDAAA;AAlBZ;AAuBQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AArBV;AAuBU;EACE,eAAA;EACA,8BAAA;AArBZ;AA0BQ;EACE,gCAAA;EACA,sCAAA;EACA,8BAAA;EACA,kBAAA;EACA,qCAAA;AAxBV;AA4BQ;EApEF;IAqEI,YAAA;IACA,aAAA;EAzBR;EA2BQ;IACE,eAAA;EAzBV;EA4BQ;IACE,mCAAA;EA1BV;AACF;AA6BQ;EAjFF;IAkFI,YAAA;IACA,aAAA;EA1BR;EA4BQ;IACE,eAAA;EA1BV;AACF;AAiCE;EACE,kBAAA;EACA,yBAAA;EAEA,2BAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAhCN;AAmCM;EACE,YAAA;EACA,WAAA;EAUA,mBAAA;AA1CR;AA2CQ;EACE,WAAA;AAzCV;;AAiDA;EACE;IACE,UAAA;IACA,mBAAA;EA9CF;EAgDA;IACE,YAAA;IACA,sBAAA;EA9CF;AACF;AAkDA;EACE;IACE,UAAA;IACA,2BAAA;EAhDF;EAkDA;IACE,UAAA;IACA,wBAAA;EAhDF;AACF;AAmDA;EACE;IACE,UAAA;IACA,qBAAA;EAjDF;EAmDA;IACE,UAAA;IACA,mBAAA;EAjDF;AACF;AAqDA;EACE,iCAAA;AAnDF;;AAsDA;EACE,2CAAA;AAnDF;;AAsDA;EACE,2CAAA;AAnDF;AAqDE;EACE,0CAAA;AAnDJ;AAsDE;EACE,0CAAA;AApDJ;;AAwDA;EACE,2CAAA;AArDF;;AAyDA;EAEI;IACE,iCAAA;EAvDJ;EAyDI;IAEE,iCAAA;EAxDN;AACF;AA8DA;EACE,6CAAA;EACA,mBAAA;AA5DF;;AAgEA;EACE;IACE,2CAAA;EA7DF;EA+DE;IACE,mCAAA;IACA,iBAAA;EA7DJ;AACF;AAkEA;EACE;IACE,gBAAA;EAhEF;EAkEE;IACE,eAAA;EAhEJ;EAmEE;IACE,eAAA;EAjEJ;EAqEA;;;;;IAKE,eAAA;EAnEF;AACF;AAqEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAnEF;AAoEE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AAlEJ","sourcesContent":["// Order Type Selection Component Styles\n// Based on \"Bestellung aufgeben für?\" design from screenshots\n\n.order-type-page {\n  background: var(--order-type-bg);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n\n  // Header styling\n  .order-type-header {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n\n    ion-toolbar {\n      --background: transparent;\n      --color: var(--text-primary-dark);\n\n      .header-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: var(--spacing-md) var(--page-padding);\n        height: var(--header-height);\n        padding: 0;\n\n        .logo {\n          font-size: var(--logo-font-size);\n          font-weight: var(--font-weight-regular);\n          color: var(--logo-color);\n          font-family: var(--font-family-primary);\n        }\n\n        .back-button,\n        .menu-button {\n          background: transparent;\n          border: none;\n          color: var(--menu-button-color);\n          cursor: pointer;\n          padding: var(--spacing-sm);\n          border-radius: var(--border-radius-sm);\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background: rgba(255, 255, 255, 0.1);\n          }\n\n          ion-icon {\n            font-size: 24px;\n          }\n        }\n\n        .back-button {\n          margin-right: auto;\n        }\n      }\n    }\n  }\n\n  // Main content area\n  .order-type-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: var(--spacing-2xl) var(--page-padding);\n    position: relative;\n  }\n\n  // Question Section\n  .question-section {\n    margin-bottom: var(--spacing-3xl);\n    text-align: center;\n\n    .question-text {\n      color: var(--order-type-color);\n      font-size: var(--font-size-h1);\n      font-weight: var(--font-weight-regular);\n      line-height: var(--line-height-tight);\n      margin: 0;\n      max-width: 500px;\n      letter-spacing: -0.01em;\n\n      // Responsive text sizing\n      @media (max-width: 768px) {\n        font-size: 28px;\n      }\n\n      @media (max-width: 480px) {\n        font-size: 24px;\n      }\n    }\n  }\n\n  // Options Section\n  .options-section {\n    margin-bottom: var(--spacing-3xl);\n\n    .option-buttons {\n      display: flex;\n      gap: var(--spacing-3xl);\n      align-items: center;\n      justify-content: center;\n\n      // Responsive layout\n      @media (max-width: 768px) {\n        gap: var(--spacing-xl);\n      }\n\n      @media (max-width: 480px) {\n        flex-direction: column;\n        gap: var(--spacing-lg);\n      }\n\n      .option-btn {\n        width: var(--option-btn-size);\n        height: var(--option-btn-size);\n        background: var(--option-btn-bg);\n        color: var(--option-btn-color);\n        border: none;\n        border-radius: var(--border-radius-full);\n        cursor: pointer;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: var(--spacing-md);\n        transition: all 0.3s ease;\n        box-shadow: var(--option-btn-shadow);\n        position: relative;\n\n        // Hover effect\n        &:hover {\n          transform: scale(1.05);\n          box-shadow: var(--option-btn-shadow-hover);\n        }\n\n        // Active/pressed effect\n        &:active {\n          transform: scale(0.98);\n        }\n\n        // Selected state\n        &.selected {\n          transform: scale(1.05);\n          box-shadow: var(--option-btn-shadow-hover);\n          \n          &::after {\n            content: '';\n            position: absolute;\n            top: -4px;\n            left: -4px;\n            right: -4px;\n            bottom: -4px;\n            border: 3px solid var(--button-primary);\n            border-radius: var(--border-radius-full);\n            animation: selectedPulse 2s ease-in-out infinite;\n          }\n        }\n\n        // Icon styling\n        .option-icon {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          ion-icon {\n            font-size: 48px;\n            color: var(--option-btn-color);\n          }\n        }\n\n        // Label styling\n        .option-label {\n          font-size: var(--font-size-body);\n          font-weight: var(--font-weight-medium);\n          color: var(--option-btn-color);\n          text-align: center;\n          line-height: var(--line-height-tight);\n        }\n\n        // Responsive sizing\n        @media (max-width: 768px) {\n          width: 160px;\n          height: 160px;\n\n          .option-icon ion-icon {\n            font-size: 40px;\n          }\n\n          .option-label {\n            font-size: var(--font-size-caption);\n          }\n        }\n\n        @media (max-width: 480px) {\n          width: 140px;\n          height: 140px;\n\n          .option-icon ion-icon {\n            font-size: 36px;\n          }\n        }\n      }\n    }\n  }\n\n  // Payment Methods Footer\n  .payment-methods {\n    position: absolute;\n    bottom: var(--spacing-xl);\n    // left: 50%;\n    transform: translateX(-50%);\n\n    .payment-icons {\n      display: flex;\n      gap: var(--spacing-md);\n      align-items: center;\n      justify-content: center;\n      // opacity: 0.7;\n\n      .payment-icon {\n        height: 32px;\n        width: 32px;\n        // filter: brightness(0.9);\n        // transition: all 0.2s ease;\n\n        &:hover {\n          // filter: brightness(1);\n          // opacity: 1;\n        }\n\n        // Ensure proper aspect ratio\n        object-fit: contain;\n        &.twint {\n          width: 65px;\n        }\n      }\n    }\n  }\n}\n\n// Selected state animation\n@keyframes selectedPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.02);\n  }\n}\n\n// Entrance animations\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n// Apply animations with staggered delays\n.order-type-page {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.question-section {\n  animation: fadeInUp 0.6s ease-out 0.2s both;\n}\n\n.options-section {\n  animation: fadeInUp 0.6s ease-out 0.4s both;\n\n  .option-btn:nth-child(1) {\n    animation: scaleIn 0.5s ease-out 0.6s both;\n  }\n\n  .option-btn:nth-child(2) {\n    animation: scaleIn 0.5s ease-out 0.7s both;\n  }\n}\n\n.payment-methods {\n  animation: fadeInUp 0.6s ease-out 0.8s both;\n}\n\n// Dark theme optimizations\n@media (prefers-color-scheme: dark) {\n  .order-type-page {\n    .option-btn {\n      box-shadow: var(--shadow-dark-lg);\n\n      &:hover,\n      &.selected {\n        box-shadow: var(--shadow-dark-xl);\n      }\n    }\n  }\n}\n\n// Focus management for accessibility\n.option-btn:focus {\n  outline: 3px solid var(--vendomat-blue-light);\n  outline-offset: 4px;\n}\n\n// High contrast mode support\n@media (prefers-contrast: high) {\n  .option-btn {\n    border: 2px solid var(--text-primary-light);\n    \n    &.selected {\n      border-color: var(--button-primary);\n      border-width: 4px;\n    }\n  }\n}\n\n// Reduced motion support\n@media (prefers-reduced-motion: reduce) {\n  .option-btn {\n    transition: none;\n    \n    &:hover {\n      transform: none;\n    }\n    \n    &.selected::after {\n      animation: none;\n    }\n  }\n  \n  .order-type-page,\n  .question-section,\n  .options-section,\n  .payment-methods,\n  .option-btn {\n    animation: none;\n  }\n}\n.external-link-section {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n  margin: 5px;\n  button {\n    display: flex;\n    background: transparent;\n    padding: 8px 12px;\n    gap: 5px;\n    margin: 5px;\n    border-radius: 6px;\n    border: 1px solid #2D69AA;\n    color: #fff;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
